<div class="container_slider  ">
    <ng-image-slider [images]="imgCollection" #nav >
    
    </ng-image-slider>
</div>